import React from 'react';

const ServicesSection = () => (
  <section id="servicios" className="w-full py-12 md:py-24 lg:py-32 bg-gray-100 dark:bg-gray-900">
    <div className="container px-4 md:px-6">
      <div className="flex flex-col items-center justify-center space-y-4 text-center">
        <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-gray-900 dark:text-gray-100">
          Nuestras Soluciones Clave
        </h2>
        <p className="max-w-[700px] text-gray-600 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-gray-400">
          Ofrecemos un abanico de servicios especializados para simplificar y potenciar tus operaciones de comercio exterior.
        </p>
      </div>
      <div className="mx-auto grid max-w-5xl items-start gap-8 py-12 sm:grid-cols-2 md:grid-cols-3">
        {[
          {
            title: "Asesoría Aduanal",
            description: "Expertos en regulaciones y procedimientos aduanales para agilizar tus operaciones.",
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
            )
          },
          {
            title: "Anexo 24 y 30",
            description: "Sistemas para el control de inventarios y cumplimiento de obligaciones fiscales.",
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                <path d="M3 9h18"></path>
                <path d="M9 21V9"></path>
              </svg>
            )
          },
          {
            title: "Expediente Digital",
            description: "Recuperación y gestión de tu expediente digital conforme a VUCEM.",
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
              </svg>
            )
          },
          {
            title: "Agencia Aduanal",
            description: "Gestión integral de tus operaciones de importación y exportación.",
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M12 8v4l3 3"></path>
              </svg>
            )
          },
          {
            title: "Logística y Transporte",
            description: "Coordinación de transporte terrestre, aéreo y marítimo para tus mercancías.",
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2v4"></path>
                <path d="m16 6 3-3"></path>
                <path d="M18 9h4"></path>
                <path d="M17 16.1V22"></path>
                <path d="M21 12h-4"></path>
                <path d="m12 18-3 3"></path>
                <path d="M8 6l-3-3"></path>
                <path d="M6 9H2"></path>
                <path d="M7 16.1V22"></path>
                <path d="M3 12h4"></path>
              </svg>
            )
          },
          {
            title: "Integración de Sistemas",
            description: "Conexión con tus sistemas mediante FTP, APIs o layouts personalizados.",
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m8 3 4 8 5-5 5 15H2L8 3z"></path>
              </svg>
            )
          }
        ].map((service, index) => (
          <div key={index} className="grid gap-2 p-6 rounded-lg border border-gray-300 bg-white shadow-sm transition-all hover:shadow-md dark:border-gray-700 dark:bg-gray-900">
            <div className="flex items-center gap-4">
              <div className="p-2 rounded-full bg-indigo-100 dark:bg-indigo-800">
                {service.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">{service.title}</h3>
            </div>
            <p className="text-gray-600 dark:text-gray-400">{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection;